/**
 * Accessibility Fixes for 47Brand theme
 * Dynamically fixes WAVE / ADA audit issues like "Spacer image missing alternative text"
 * without modifying layout, design, or existing features.
 */
(function () {
  function fixSpacerImages() {
    const images = document.querySelectorAll('img');
    images.forEach(function (img) {
      // Detect spacer, layout, or decorative images:
      // 1. Has class 'opacity-0' (used in this theme to maintain aspect ratio for video blocks)
      // 2. Is very small (width <= 10px or height <= 10px, common for 1x1 spacer GIFs / tracking pixels)
      // 3. Filename/URL contains common spacer identifiers (spacer, pixel, clear, trans, etc.)
      const isOpacityZero = img.classList.contains('opacity-0');
      const isTiny = (img.width > 0 && img.width <= 10) || (img.height > 0 && img.height <= 10) ||
        (img.getAttribute('width') && parseInt(img.getAttribute('width')) <= 10) ||
        (img.getAttribute('height') && parseInt(img.getAttribute('height')) <= 10);
      const isSpacerSrc = /spacer|pixel|clear|trans|gif/i.test(img.src || '');

      const isSpacer = isOpacityZero || isTiny || isSpacerSrc;

      if (isSpacer) {
        // Apply accessibility attributes to hide the spacer image from screen readers
        if (img.getAttribute('alt') !== '') {
          img.setAttribute('alt', '');
        }
        if (img.getAttribute('role') !== 'presentation') {
          img.setAttribute('role', 'presentation');
        }
        if (img.getAttribute('aria-hidden') !== 'true') {
          img.setAttribute('aria-hidden', 'true');
        }
      }
    });
  }

  function fixNarvarDates() {
    const dates = document.querySelectorAll('.narvar-edd-date');
    dates.forEach(function (el) {
      const hasText = el.textContent && el.textContent.trim().length > 0;
      if (hasText) {
        if (el.style.display === 'none') {
          el.style.display = '';
        }
      } else {
        if (el.style.display !== 'none') {
          el.style.display = 'none';
        }
      }
    });
  }

  function fixHiddenFormLabels() {
    const hiddenInputs = document.querySelectorAll(
      '#cf_hidden_forms input, [data-cf-ignore="true"] input, #cf_hidden_forms select, #cf_hidden_forms textarea'
    );

    hiddenInputs.forEach(function (input) {
      // 1. Explicitly set type to hidden if missing or default text
      if (!input.getAttribute('type') || input.getAttribute('type') === 'text') {
        input.setAttribute('type', 'hidden');
      }

      // 2. Add aria-label if missing
      if (!input.hasAttribute('aria-label')) {
        const rawName = input.getAttribute('name') || input.getAttribute('id') || 'hidden-field';
        const labelText = rawName
          .replace(/[\[\]_.-]+/g, ' ')
          .trim()
          .replace(/\b\w/g, function (c) {
            return c.toUpperCase();
          }) || 'Hidden Form Field';

        input.setAttribute('aria-label', labelText);
      }

      // 3. Mark as hidden and non-focusable
      if (input.getAttribute('aria-hidden') !== 'true') {
        input.setAttribute('aria-hidden', 'true');
      }
      if (input.getAttribute('tabindex') !== '-1') {
        input.setAttribute('tabindex', '-1');
      }
    });
  }

  /**
   * Fixes "ARIA attributes must conform to valid values" issue reported by Axe DevTools on Swiper navigation buttons.
   * When Swiper Web Components (<swiper-container>) initialize, Swiper dynamically
   * injects an `aria-controls` attribute targeting the carousel wrapper ID.
   * Because that ID exists inside the Web Component's Shadow DOM, light-DOM
   * elements cannot reference IDs across the Shadow DOM boundary. Axe DevTools flags
   * this as "ARIA attributes must conform to valid values".
   * Removing `aria-controls` resolves the audit error without affecting functionality.
   */
  function fixSwiperNavAriaControls() {
    const swiperNavButtons = document.querySelectorAll('.swiper-nav button[aria-controls]');
    swiperNavButtons.forEach(function (button) {
      button.removeAttribute('aria-controls');
    });
  }

  function runAllFixes() {
    fixSpacerImages();
    fixNarvarDates();
    fixHiddenFormLabels();
    fixSwiperNavAriaControls();
  }

  // Initial runs
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAllFixes);
  } else {
    runAllFixes();
  }
  window.addEventListener('load', runAllFixes);

  // Monitor DOM changes to handle lazy-loaded, swiper, or AJAX-rendered elements
  const observer = new MutationObserver(function (mutations) {
    let shouldFix = false;
    for (let i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length > 0 || mutations[i].type === 'characterData') {
        shouldFix = true;
        break;
      }
    }
    if (shouldFix) {
      runAllFixes();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();
